import { Ref, useCallback, useRef } from "react";

export function useScopedKeys<T extends HTMLElement>(handlers: {
    [key: string]: ((e: KeyboardEvent) => void) | undefined | null;
}): Ref<T> {
    const deps = [...Object.keys(handlers), ...Object.values(handlers)];
    const unsub = useRef<(() => void) | null>(null);

    return useCallback((el: T | null) => {
        unsub.current?.();
        unsub.current = null;

        if (!el) {
            return;
        }

        const handler = (e: KeyboardEvent) => {
            const keyHandler = handlers[e.key];
            if (keyHandler) {
                keyHandler(e);
            }
        };

        el.addEventListener("keydown", handler);
        unsub.current = () => {
            el.removeEventListener("keydown", handler);
        };
    }, deps);
}
